/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/jvm/code-size': {
    put: {
      minApiVersion: 1.9,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint32',
      },
    },
  },

  '/jvm/code': {
    put: {
      minApiVersion: 1.9,
      configModeRequired: true,
      schema: {
        $ref: './definitions.yaml#/Bytes',
      },
    },
  },

  '/jvm/clear-code': {
    put: {
      minApiVersion: 1.9,
      configModeRequired: true,
      schema: undefined,
    },
  },

  '/jvm/profile-id': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },

  '/jvm/log-and-clear': {
    put: {
      minApiVersion: 2.11,
      configModeRequired: true,
      schema: undefined,
    },
  },

  '/jvm/log': {
    put: {
      minApiVersion: 2.11,
      configModeRequired: true,
      schema: {
        type: 'string',
        example: 'My log value',
      },
    },
  },
};
